import dayjs from 'dayjs';
import dayjsRelativeTimePlugin from 'dayjs/plugin/relativeTime';

import type {NotificationEvent} from '../../../../../api/event';
import type {RenderContract} from '../../NotificationsListItemDumb/types';
import type {EventContextsMap} from '../types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';

dayjs.extend(dayjsRelativeTimePlugin);

export const getEventData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): RenderContract => {
  let date = '';

  const eventDate = dayjs(datetimeObjToISOString(event.created));

  if (eventDate.isSame(dayjs(), 'day')) {
    date = eventDate.fromNow();
  } else {
    date = eventDate.format('llll');
  }

  const data: RenderContract = {
    avatarPlaceholder: event.type.replace(/_/g, ' '),
    date,
    title: event.type.replace(/_/g, ' '),
  };

  let specificData = {};

  switch (event.type) {
    case 'availability_needs_to_be_updated_3days_before':
      specificData =
        require('./availability_needs_to_be_updated_3days_before').getData(
          event,
          contexts,
        );
      break;
    case 'availability_needs_to_be_updated_now':
      specificData = require('./availability_needs_to_be_updated_now').getData(
        event,
        contexts,
      );
      break;
    case 'availability_needs_to_be_updated_week_before':
      specificData =
        require('./availability_needs_to_be_updated_week_before').getData(
          event,
          contexts,
        );
      break;
    case 'bound_form_missed':
      specificData = require('./bound_form_missed').getData(event, contexts);
      break;
    case 'certificate_approved':
    case 'certificate_rejected':
      specificData = require('./certificate_approved').getData(event, contexts);
      break;
    case 'coach_became_restricted':
    case 'coach_verification_required':
    case 'coach_verified':
      specificData = require('./coach_verified').getData(event, contexts);
      break;
    case 'coach_didnt_send_1st_message_1':
    case 'coach_didnt_send_1st_message_2':
      specificData = require('./coach_didnt_send_1st_message').getData(
        event,
        contexts,
      );
      break;
    case 'coach_matched':
      specificData = require('./coach_matched').getData(event, contexts);
      break;
    // B2B
    case 'coach_schedule_until_expired':
      specificData = require('./coach_schedule_until_expired').getData(
        event,
        contexts,
      );
      break;
    case 'coach_video_approved':
    case 'coach_video_rejected':
      specificData = require('./coach_video_approved').getData(event, contexts);
      break;
    case 'complaint_received':
      specificData = require('./complaint_received').getData(event, contexts);
      break;
    case 'conference_archived':
    case 'conference_archives_shared':
    case 'conference_pending':
    case 'conference_rescheduled':
    case 'conference_scheduled':
    case 'conference_started':
    case 'conference_taken':
    case 'conference_upcoming':
    case 'conference_upcoming_5min':
    case 'user_canceled_session':
      specificData = require('./conference_upcoming').getData(event, contexts);
      break;
    case 'conference_client_joined':
      specificData = require('./conference_client_joined').getData(
        event,
        contexts,
      );
      break;
    case 'conference_still_active':
      specificData = require('./conference_still_active').getData(
        event,
        contexts,
      );
      break;
    case 'conference_stopped_automatically':
      specificData = require('./conference_stopped_automatically').getData(
        event,
        contexts,
      );
      break;
    case 'course_created':
    case 'course_pending':
    case 'course_started':
      specificData = require('./course_created').getData(event, contexts);
      break;
    // B2B
    case 'course_extended':
      specificData = require('./course_extended').getData(event, contexts);
      break;
    case 'course_is_already_ended':
      specificData = require('./course_is_already_ended').getData(
        event,
        contexts,
      );
      break;
    case 'course_paused':
    case 'course_resumed':
      specificData = require('./course_paused').getData(event, contexts);
      break;
    case 'course_stopped':
      specificData = require('./course_stopped').getData(event, contexts);
      break;
    case 'course_stopped_restarting':
      specificData = require('./course_stopped_restarting').getData(
        event,
        contexts,
      );
      break;
    case 'edition_created':
    case 'edition_signed':
      specificData = require('./edition_created').getData(event, contexts);
      break;
    // B2B
    case 'end_of_program_reminder':
      specificData = require('./end_of_program_reminder').getData(
        event,
        contexts,
      );
      break;
    case 'goal_client_review_expiring':
    case 'goal_client_review_reminder':
      specificData = require('./goal_client_review_reminder').getData(
        event,
        contexts,
      );
      break;
    case 'goal_coach_review_expiring':
    case 'goal_coach_review_reminder':
      specificData = require('./goal_coach_review_reminder').getData(
        event,
        contexts,
      );
      break;
    case 'goal_reached':
      specificData = require('./goal_reached').getData(event, contexts);
      break;
    case 'google_oauth_access_became_invalid':
      specificData = require('./google_oauth_access_became_invalid').getData(
        event,
        contexts,
      );
      break;
    case 'invite_received':
      specificData = require('./invite_received').getData(event, contexts);
      break;
    case 'materials_disclosed':
      specificData = require('./materials_disclosed').getData(event, contexts);
      break;
    case 'membership_accepted':
    case 'membership_created':
    case 'membership_requested':
      specificData = require('./membership_created').getData(event, contexts);
      break;
    case 'membership_declined':
      specificData = require('./membership_declined').getData(event, contexts);
      break;
    case 'membership_declined_by_client':
      specificData = require('./membership_declined_by_client').getData(
        event,
        contexts,
      );
      break;
    case 'membership_expired':
      specificData = require('./membership_expired').getData(event, contexts);
      break;
    case 'membership_frozen':
    case 'membership_unfrozen':
      specificData = require('./membership_frozen').getData(event, contexts);
      break;
    case 'membership_proposed':
      specificData = require('./membership_proposed').getData(event, contexts);
      break;
    case 'membership_revoked':
      specificData = require('./membership_revoked').getData(event, contexts);
      break;
    case 'offered_program_created_client':
      specificData = require('./offered_program_created_client').getData(
        event,
        contexts,
      );
      break;
    case 'offered_program_created_coach':
      specificData = require('./offered_program_created_coach').getData(
        event,
        contexts,
      );
      break;
    case 'payment_failed':
      specificData = require('./payment_failed').getData(event, contexts);
      break;
    case 'payment_marked_paid':
      specificData = require('./payment_marked_paid').getData(event, contexts);
      break;
    case 'payment_refund_failed':
      specificData = require('./payment_refund_failed').getData(
        event,
        contexts,
      );
      break;
    case 'payment_refunded':
      specificData = require('./payment_refunded').getData(event, contexts);
      break;
    case 'payment_requires_action':
      specificData = require('./payment_requires_action').getData(
        event,
        contexts,
      );
      break;
    case 'payment_reversed':
    case 'payment_successful':
      specificData = require('./payment_successful').getData(event, contexts);
      break;
    case 'payment_transferred':
      specificData = require('./payment_transferred').getData(event, contexts);
      break;
    case 'payment_upcoming':
      specificData = require('./payment_upcoming').getData(event, contexts);
      break;
    case 'program_rejected':
    case 'program_resigned':
    case 'program_signed':
    case 'program_updated':
      specificData = require('./program_updated').getData(event, contexts);
      break;
    case 'program_shared':
      specificData = require('./program_shared').getData(event, contexts);
      break;
    case 'questionnaire_completed':
      specificData = require('./questionnaire_completed').getData(
        event,
        contexts,
      );
      break;
    case 'refund_requested':
      specificData = require('./refund_requested').getData(event, contexts);
      break;
    case 'subgoal_reached':
      specificData = require('./subgoal_reached').getData(event, contexts);
      break;
    case 'task_done':
      specificData = require('./task_done').getData(event, contexts);
      break;
    case 'task_overdue':
      specificData = require('./task_overdue').getData(event, contexts);
      break;
    case 'task_pending':
      specificData = require('./task_pending').getData(event, contexts);
      break;
    default:
      break;
  }

  return {...data, ...specificData};
};
